export const tr = {
    cancel: 'İptal',
    'set-smart-center': "Akıllı Merkez'i kur",
    'smart-center-title': 'Akıllı Merkez'
};
